import { Component, DestroyRef, inject, OnDestroy, OnInit, AfterViewChecked, ViewChild, ElementRef } from '@angular/core';
import { retry, Subject, takeUntil } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { DirectorService } from "./director.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import * as forge from 'node-forge';
import { MatProgressBar } from "@angular/material/progress-bar";
import {
  FormBuilder, FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
  ɵFormGroupRawValue,
  ɵGetProperty,
  ɵTypedOrUntyped,
  FormsModule
} from "@angular/forms";
import { CurrencyPipe, NgForOf, NgIf, CommonModule } from "@angular/common";
import { MatFormField } from "@angular/material/form-field";
import { MatInput, MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatOption, MatSelect } from "@angular/material/select";
import { MatCheckbox, MatCheckboxModule } from "@angular/material/checkbox";
import { ModelValidators } from "../../validators/validators";
import { MatIcon } from "@angular/material/icon";
import { CardDetailsComponent } from '../components/card-details/card-details.component';
import { AddressComponent } from '../components/address/address.component';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';  // Import MatSnackBar
import { MatSnackBarModule } from '@angular/material/snack-bar';  // Import MatSnackBarModule
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card'
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { RadioCardComponent } from '../components/radio-card/radio-card.component';


// export function cvvValidator(cardTypeControl: AbstractControl | null | undefined): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     if (!cardTypeControl) {
//       return null; // or return an appropriate error if needed
//     }
//     const cardType = cardTypeControl.value;
//     const cvv = control.value;
//     if (cardType === 'amex' && cvv.length !== 4) {
//       console.log('American Express CVV must be 4 digits');
//       return { invalidCvv: 'American Express CVV must be 4 digits' };
//     } else if (cardType !== 'amex' && cvv.length !== 3) {
//       console.log('CVV must be 3 digits');
//       return { invalidCvv: 'CVV must be 3 digits' };
//     }
//     return null;
//   };
// }
declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage: (message: string) => void;
    };
  }
}

export interface PathInterface {
  readonly patient_id: number;
  readonly practice_id: number;
  readonly meeting_id: string;
};

export interface RsaKemSubmitInterface {
  ciphertext_aes_B64: string;
  ciphertext_rsa_B64: string;
  ivB64: string;
  tagB64: string;
};

export interface StoredCardApiItem {
  billingaddress: string;
  billingzip: string;
  cardexpirationmmyyyy: string;
  cardnumberlast4digits: string;
  cardtype: string;
  nameoncard: string;
  status: string;
  storedcardid: number;
}

export interface CardItem {
  id: string;
  bankName: string;
  isNew: boolean;
  maskedNumber?: string;
  type?: 'visa' | 'mastercard' | 'amex' | 'discover' | 'applePay' | 'googlePay' | 'new';
  originalCardData?: StoredCardApiItem;
}

export interface PaymentOptionItem {
  id: 'full' | 'partial' | 'plan';
  label: string;
  amount?: number;
}

@Component({
  selector: 'app-director',
  standalone: true,
  imports: [
    MatInputModule,
    MatButtonModule,
    MatProgressBar,
    ReactiveFormsModule,
    NgIf,
    MatFormField,
    MatInput,
    MatSelect,
    MatOption,
    NgForOf,
    MatIcon,
    CardDetailsComponent,
    AddressComponent,
    CurrencyPipe,
    MatSnackBarModule,
    FormsModule,
    CommonModule,
    MatDialogModule,
    MatCardModule,
    MatRadioButton,
    MatRadioModule,
    RadioCardComponent,
    MatCheckbox,
    MatCheckboxModule
  ],
  providers: [CurrencyPipe],
  templateUrl: './director.component.html',
  styleUrl: './director.component.css'
})
export class DirectorComponent implements OnInit, AfterViewChecked, OnDestroy {

  is_loading: boolean = true;
  dirPay: string | null = null;
  showPay: boolean = false;
  isSubmitting: boolean = false;
  isPayNowLoading: boolean = false;
  isSkipPaymentLoading: boolean = false;
  isSkipDirectLoading: boolean = false;
  skipPaymentError: string = '';
  showSkipButton: boolean = false;
  showInputError: { [key: string]: boolean } = {};
  balance: number = 0;
  currentBalance: number = 0;
  remainingBalance: number = 0;
  amountToPay: string = '';
  isAmountValid = false; pathData: PathInterface | undefined
  myForm!: FormGroup;
  errorMessage: string | null = null;
  mrn: string = '';
  pid: string = '';
  isReactNative: boolean = false;
  private destroyRef = inject(DestroyRef);
  destroyed_interval = new Subject();
  selectedCard: string = 'newCard';
  // cardsList: CardItem[] = [
  //   {
  //     id: 'savedCard',
  //     bankName: 'Saved card',
  //     isNew: false,
  //     maskedNumber: '**** 4789',
  //     type: 'visa'
  //   },
  //   {
  //     id: 'newCard',
  //     bankName: 'New card',
  //     isNew: true,
  //     type: 'new'
  //   },
  //   // {
  //   //   id: 'applePay',
  //   //   bankName: 'Apple Pay', // Or an empty string if just an icon
  //   //   isNew: false,
  //   //   type: 'applePay' // Custom type for Apple Pay
  //   // },
  //   // {
  //   //   id: 'googlePay',
  //   //   bankName: 'G Pay', // Or an empty string if just an icon
  //   //   isNew: false,
  //   //   type: 'googlePay' // Custom type for Google Pay
  //   // }
  // ];
  cardsList: CardItem[] = [];

  selectedPaymentOptionId: string = 'full';
  paymentOptions: PaymentOptionItem[] = [];
  partialAmountForm!: FormGroup;
  minPartialAmount: number = 0;
  payNowButtonAmount: number = 0;
  isPartialAmountEntered: boolean = false;
  displayOutstandingBalance: string = '$0.00';
  displayCopayAmount: string = '$0.00';
  displayTotalBalanceCard: string = '$0.00';

  @ViewChild('partialAmountInput') partialAmountInputField!: ElementRef;
  clickBlockedForSnack!: boolean;
  totalBalance: number = 0;
  currentAppointmentId: string = '';
  currentCopayAmountFromApi: number = 0;
  currentDepartmentId: string = '';
  currentPracticeId: number = 0;
  patientid: any;
  otheramountValue: any;
  savedCardCvvForm!: FormGroup;
  selectedSavedCardType!: string;
  showAdvancedOptionsPage: boolean = false;
  friendlyProviderText: string = '';
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private directorService: DirectorService,
    private http: HttpClient,
    private currencyPipe: CurrencyPipe,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {
    this.partialAmountForm = this.fb.group({
      partialAmount: ['', [Validators.required, Validators.min(this.minPartialAmount)]]
    });
    this.savedCardCvvForm = this.fb.group({
      cvv: ['', [Validators.required]]
    });
  } // end of constructor

  year_list: { value: string; viewValue: string; }[] = [];
  ngOnInit(): void {

    const slug = environment?.SLUG || '';
    this.friendlyProviderText = this.getFriendlySlugText(slug);

    this.isReactNative = !!window.ReactNativeWebView;
    localStorage.setItem('is_react_native_webview', this.isReactNative ? 'true' : 'false');

    this.route.queryParams.subscribe((params) => {
      let balanceValue: string | null = null;
      let dirPayParam: string | null = null;

      if (params['pid']) {
        this.pid = params['pid'];
      }
      // Check if balance is present in the query string
      if (params['balance']) {
        balanceValue = params['balance'];
        localStorage.setItem('providerName', params['provider'])
        this.setFavIcon(params['provider']);
      } else {
        // Fallback to checking the meta tag
        const balanceMetaTag = document.querySelector('meta[name="balance"]');
        const balanceValue = balanceMetaTag?.getAttribute('content');
        //console.log('Balance found in meta tag:', balanceValue);
      }
      this.currentBalance = balanceValue ? parseFloat(balanceValue) : 0;

      if (isNaN(this.currentBalance)) {
        console.error('Invalid balance value:', balanceValue);
        this.currentBalance = 0;
      }
      // Parse and validate balance value
      // if (balanceValue) {
      //   const parsedBalance = parseFloat(balanceValue);
      //   if (!isNaN(parsedBalance)) {
      //     this.balance = parseFloat(parsedBalance.toFixed(2)); // Ensure it is stored as a number
      //   } else {
      //     console.warn('Balance value is not a valid number');
      //     this.balance = 0; // Default to 0 if the value is invalid
      //   }
      // } else {
      //   console.warn('Balance not found in query string or meta tag');
      //   this.balance = 0; // Default to 0 if the value is missing
      // }
      // this.updateRemainingBalance();

      this.initializePaymentOptions();
      this.payNowButtonAmount = this.balance;

      this.partialAmountForm.get('partialAmount')?.setValidators([
        Validators.required,
        Validators.min(this.minPartialAmount),
        Validators.max(this.balance > 0 ? this.balance : 999999)
      ]);
      this.partialAmountForm.get('partialAmount')?.updateValueAndValidity();

      // Check if dirPay is present in the query string
      if (params['dirPay']) {
        dirPayParam = params['dirPay'];
        this.dirPay = dirPayParam;
      } else {
        // Fallback to checking the meta tag
        this.dirPay = 'true';
      }
    });
    /*
      https://www.americanexpress.com/content/dam/amex/hk/en/staticassets/merchant/pdf/support-and-services/useful-information-and-downloads/GuidetoCheckingCardFaces.pdf
     */

    const currentYear = new Date().getFullYear();
    this.year_list = Array.from({ length: 5 }, (_, i) => ({
      value: (currentYear + i).toString(),
      viewValue: (currentYear + i).toString()
    }));

    this.route.params.subscribe(parms => {
      const ciphertext = parms['ciphertext'];
      this.getData(ciphertext);
    })

    this.destroyRef.onDestroy(() => {
      this.destroyed_interval.next('');
      this.destroyed_interval.complete();
    });

    this.myForm = this.fb.group({
      nameoncard: ['', [Validators.required]],
      cardtype: ['', [Validators.required]],
      billingaddress: ['', [Validators.required]],
      billingzip: ['', [Validators.required, ModelValidators.zipCodeValidator]],
      accountnumber: ['', [Validators.required]],
      accountnumber_amex: [''],
      cardsecuritycode: ['', [Validators.required, ModelValidators.cvvValidator]],
      cardsecuritycode_amex: [''],
      expirationmonthmm: ['', [Validators.required]],
      expirationyearyyyy: ['', [Validators.required]],
      expirationDate: new FormControl(''),
      otheramount: ['', [ModelValidators.validPaymentAmountValidator]],
      departmentid: [''],
      storedcardid: [''],
      saveCardDetails: [false]
    });
  } // end of ngOnInit
  ngAfterViewChecked(): void {
    // Retrieve the balance meta tag value
    // const balanceMetaTag = document.querySelector('meta[name="balance"]');
    // const balanceValue = balanceMetaTag?.getAttribute('content');

    // // Check if the meta tag "balance" exists
    // if (balanceValue) {
    //   const parsedBalance = parseFloat(balanceValue);
    //   if (!isNaN(parsedBalance)) {
    //     // If valid, set `balance` and `otheramount`
    //     this.balance = parsedBalance;
    //     this.myForm.get('otheramount')?.setValue(this.balance);
    //   } else {
    //     console.warn('Balance value in meta tag is not a valid number');
    //     this.balance = 0;
    //     this.myForm.get('otheramount')?.setValue(0);
    //   }
    // } else {
    //   // If no balance meta tag, fallback to query params
    //   const params = this.route.snapshot.queryParams;
    //   if (params['dirPay'] === 'false') {
    //     // Get balance and otheramount from the input
    //     const inputBalance = parseFloat(this.amountToPay.replace('$', '') || '0');
    //     if (!isNaN(inputBalance)) {
    //       this.balance = inputBalance;
    //       this.myForm.get('otheramount')?.setValue(this.balance);
    //     } else {
    //       console.warn('Input balance is not a valid number');
    //       this.balance = 0;
    //       this.myForm.get('otheramount')?.setValue(0);
    //     }
    //   }
    // }

    // Handle the provider meta tag logic
    const params = new URLSearchParams(window.location.search);
    let providerName: string | null = null;

    // Check if the `provider` parameter exists in the URL
    if (params.has('provider')) {
      providerName = params.get('provider')?.trim() || '';
      //console.log('Provider name from URL parameter:', providerName);
    } else {
      // Fallback to the meta tag
      const providerMeta = document.querySelector('meta[name="provider"]') as HTMLMetaElement;
      if (providerMeta && providerMeta.content) {
        providerName = providerMeta.content.trim();
        //console.log('Provider name from meta tag:', providerName);
      }
    }

    // Add the provider name as a class to the body if it exists
    if (providerName) {
      localStorage.setItem('providerName', providerName);
      document.body.classList.add(`provider-${providerName}`);
    } else {
      console.warn('Provider name not found in URL parameter or meta tag.');
    }

  }
  setFavIcon(slug: string) {
    const icon = document.querySelector('link[rel="icon"]');
    if (icon) {
      icon.setAttribute('href', `/assets/icons/${slug}-fav.ico`);
    } else {
      console.error('Meta tag with property "twitter:image" not found');
    }
  }

  // Handle input changes dynamically
  handleInputAmountChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    let numericValue = inputElement.value.replace(/[^0-9.]/g, ''); // Allow only numbers and a single dot

    // Ensure only one decimal point is allowed
    if (numericValue.split('.').length > 2) {
      numericValue = numericValue.slice(0, numericValue.lastIndexOf('.'));
    }

    // Restrict to 2 decimal places
    if (numericValue.includes('.')) {
      const [integer, decimal] = numericValue.split('.');
      numericValue = `${integer}.${(decimal || '').slice(0, 2)}`;
    }

    this.amountToPay = numericValue ? `$${numericValue}` : ''; // Add $ dynamically

    this.updateRemainingBalance();
  }

  // Handle blur event for validation and formatting
  handleInputBlur(): void {
    const numericValue = parseFloat(this.amountToPay.replace('$', '') || '0');

    if (numericValue > 1500) {
      // Exceeds maximum allowed value
      this.snackBar.open(
        'The amount cannot exceed $1500.00. Adjusted to $1500.00.',
        'Close',
        {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['error-snackbar']
        }
      );
      this.amountToPay = `$1500.00`;
      setTimeout(() => {
        this.isAmountValid = numericValue > 0;
      }, 1000);
    } else if (numericValue <= 0) {
      // Invalid amount
      this.amountToPay = `$0.00`;
    } else {
      // Valid amount
      this.amountToPay = `$${numericValue.toFixed(2)}`;
      this.isAmountValid = numericValue > 0;

    }

    this.updateRemainingBalance();
  }

  // Update remaining balance dynamically
  updateRemainingBalance(): void {
    const numericValue = parseFloat(this.amountToPay.replace('$', '') || '0');
    this.remainingBalance = this.currentBalance - numericValue;
  }

  // Check if the amount is invalid
  isInvalidAmount(): boolean {
    const numericValue = parseFloat(this.amountToPay.replace('$', '') || '0');
    return numericValue <= 0 || numericValue > this.currentBalance;
  }
  proceedToPayment(): void {
    const numericValue = parseFloat(this.amountToPay.replace('$', '') || '0');

    if (!numericValue || numericValue <= 0 || isNaN(numericValue)) {
      this.snackBar.open('Please enter an amount to pay.', 'OK', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['error-snackbar']
      });
      this.isPayNowLoading = false;
      return;
    }

    this.dirPay = 'true';
  }
  getSupportPhoneNumber(): string {
    switch ((environment?.SLUG || '').toLowerCase()) {
      case 'healent':
        return 'tel:+1312-635-0973';
      case 'akps':
        return 'tel:+1312-635-0973';
      case 'mypainsolution':
        return 'tel:+1312-635-0973';
      default:
        return 'tel:+1312-635-0973';
    }
  }
  openDialer(event: Event): void {
    event.preventDefault();
    window.location.href = this.getSupportPhoneNumber();
  }
  skip(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {

      data: {
        icon: 'healent-x33-1',
        title: 'Pay at Front Desk',
        message: 'Select this option only if you\'re unable to pay online. Are you sure you want to pay at the front desk instead?',
        buttons: [
          { text: 'Yes', value: true, class: 'dialog-yes-button' },
          { text: 'No', value: false, class: 'dialog-no-button' }
        ]
      },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.skipPaymentError = '';
        this.isSkipPaymentLoading = true;
        this.callSkipApi(true);
      }
    });
  }

  skipDirect(): void {
    this.skipPaymentError = '';
    this.isSkipDirectLoading = true;
    this.callSkipApi(false);
  }

  callSkipApi(sendPayAtFrontDeskParams: boolean = true): void {
    if (!this.pid) {
      console.error('Error: Patient ID is missing.');
      this.isSkipPaymentLoading = false;
      return;
    }

    const currentQueryParams = this.route.snapshot.queryParams;

    const url = `${environment.API_URL}/form/payment/skip/${this.pid}/${currentQueryParams['meetingId']}`;

    this.http.get(url).subscribe({
      next: () => {
        this.route.queryParams.subscribe((params) => {
          const consentsFormsIncomplete = params['consents_forms_incomplete'];
          
          const queryParams: any = {
            ...consentsFormsIncomplete ? { consents_forms_incomplete: consentsFormsIncomplete } : {},
            weblogin: currentQueryParams['weblogin']
          };
          
          if (sendPayAtFrontDeskParams) {
            queryParams.payAtFrontDesk = true;
            queryParams.remainingBalance = this.totalBalance;
          }
          
          this.router.navigate(['/form-done'], { queryParams });
        });
      },
      error: (error) => {
        console.error('Error skipping payment:', error);
        this.isSkipPaymentLoading = false;
        this.isSkipDirectLoading = false;
        this.skipPaymentError = 'Failed to process front desk payment.';
      }
    })
  }



  isValidNumber(value: any): boolean {
    return !isNaN(value) && value !== null && value !== '';
  }
  get nameOnCardControl(): FormControl {
    return this.myForm.get('nameoncard') as FormControl;
  }
  get accountnumberControl(): FormControl {
    return this.myForm.get('accountnumber') as FormControl;
  }
  get expirationDateControl(): FormControl {
    return this.myForm.get('expirationDate') as FormControl;
  }
  get securityCodeControl(): FormControl {
    return this.myForm.get('securityCode') as FormControl;
  }

  private _mapCardTypeToIcon(cardType: string): 'visa' | 'mastercard' | 'amex' | 'discover' | 'new' | undefined {
    switch (cardType.toLowerCase()) {
      case 'visa': return 'visa';
      case 'mastercard': return 'mastercard';
      case 'american express': return 'amex';
      case 'discover': return 'discover';
      default: return undefined;
    }
  }

  getData(ciphertext: string) {
    const endpoint = `${environment.API_URL}/secure/director/decrypt/${ciphertext}`;
    this.http.get<any>(endpoint).subscribe(
      response => {
        this.pathData = response['message']['path'];
        //console.log('response', response);
        this.mrn = response['message'].patientid;
        //console.log('mrn', this.mrn);

        this.currentAppointmentId = response.message.appointmentid || '';
        this.currentCopayAmountFromApi = parseFloat(response.message.copayamount || '0') || 0;
        this.currentDepartmentId = response.message.departmentid || '';
        this.currentPracticeId = response.message.practiceid || 0;
        this.patientid = response.message.patientid || 0;
        this.otheramountValue = response.message.otheramount || 0;

        this.myForm.get('otheramount')?.setValue(response['message'].otheramount);
        this.myForm.get('departmentid')?.setValue(response['message'].departmentid);

        const parsedOtherAmount = parseFloat(response.message.otheramount || '0') || 0;
        const parsedCopayAmount = parseFloat(response.message.copayamount || '0') || 0;
        
        this.balance = parsedOtherAmount;
        const displayTotalAmountNum = parsedOtherAmount + parsedCopayAmount;

        this.displayOutstandingBalance = this.currencyPipe.transform(parsedOtherAmount, 'USD', 'symbol', '1.2-2') || '$0.00';
        this.displayCopayAmount = this.currencyPipe.transform(parsedCopayAmount, 'USD', 'symbol', '1.2-2') || '$0.00';
        this.displayTotalBalanceCard = this.currencyPipe.transform(displayTotalAmountNum, 'USD', 'symbol', '1.2-2') || '$0.00';

        this.totalBalance = displayTotalAmountNum;

        // Check if skip button should be shown (zero or negative balance)
        this.showSkipButton = parsedOtherAmount + parsedCopayAmount <= 0;

        this.initializePaymentOptions();

        const newCardsList: CardItem[] = [];

        // Map storedcards from API response
        if (response.message.storedcards && response.message.storedcards.length > 0) {
          response.message.storedcards.forEach((card: any) => {
            newCardsList.push({
              id: String(card.storedcardid),
              bankName: card.nameoncard,
              isNew: false,
              maskedNumber: `**** ${card.cardnumberlast4digits}`,
              type: this._mapCardTypeToIcon(card.cardtype),
              originalCardData: card
            });
          });
        }
        newCardsList.push({
          id: 'newCard',
          bankName: 'New card',
          isNew: true,
          type: 'new'
        });

        this.cardsList = newCardsList;
        if (this.cardsList.length > 1) {
          this.selectedCard = this.cardsList[0].id;
          const firstCard = this.cardsList[0];
          this.selectedSavedCardType = firstCard.type || '';
        } else {
          this.selectedCard = 'newCard';
        }

        this.partialAmountForm.get('partialAmount')?.setValidators([
          Validators.required,
          Validators.min(this.minPartialAmount),
          Validators.max(this.balance > 0 ? this.balance : 999999)
        ]);
        this.partialAmountForm.get('partialAmount')?.updateValueAndValidity();

        setTimeout(() => {
          this.is_loading = false;
        }, 2000);
        if (this.pathData === undefined) {
          return;
        }
        //this.router.navigate([`/collect-payment/${ciphertext}`]);
      },
      error => {
        this.totalBalance = 0;
        this.balance = 0;
        this.initializePaymentOptions();
        this.cardsList = [{ id: 'newCard', bankName: 'New card', isNew: true, type: 'new' }];
        this.selectedCard = 'newCard';
        this.partialAmountForm.get('partialAmount')?.setValidators([
          Validators.required,
          Validators.min(this.minPartialAmount),
          Validators.max(this.balance > 0 ? this.balance : 999999)
        ]);
        this.partialAmountForm.get('partialAmount')?.updateValueAndValidity();
        setTimeout(() => {
          this.is_loading = false;
        }, 2000);
        console.error('Error fetching user data:', error);
      }
    );
  } // end of getData


  ngOnDestroy(): void {
    this.destroyed_interval.next('');
    this.destroyed_interval.complete();
  } // end of ngOnDestroy

  rsaKem(message: string) {

    var x_api_key = environment.SLUG;


    /*******************************************************************/
    /* GENERATE RANDOM AND FIXED DATA FOR AES
    /*******************************************************************/
    //var aes_key = forge.random.getBytesSync(16); // CryptoJS.lib.WordArray.random(16).toString();  //THIS IS A RANDOM AES KEY
    var aes_key = forge.util.encode64(forge.random.getBytesSync(16));  // THIS IS A RANDOM AES KEY
    var iv = forge.random.getBytesSync(16);  //create a random IV 128
    var msgBytes = forge.util.createBuffer(message, 'utf8');  // MESSAGE WE WANT TO ENCRYPT
    var additionalData = x_api_key //THIS WILL BE THE API KEY AND IS TREATED AS FIXED
    var tagLength = 128; //FIXED DATA

    /*******************************************************************/
    /* ENCRYPT AES-GCM 256
    /*******************************************************************/
    // encrypt some bytes using GCM mode
    var cipher = forge.cipher.createCipher('AES-GCM', aes_key);
    cipher.start({
      iv: iv, // should be a 12-byte binary-encoded string or byte buffer
      additionalData: additionalData, // optional
      tagLength: tagLength // optional, defaults to 128 bits
    });
    cipher.update(forge.util.createBuffer(msgBytes));
    cipher.finish();

    // GET OUTPUTS AND PRINT
    var encrypted = cipher.output;
    var tag = cipher.mode.tag;
    //console.log('encrypted.toHex():',encrypted.toHex(), encrypted.data);
    const ivB64 = forge.util.encode64(iv);
    const ciphertext_aes_B64 = forge.util.encode64(encrypted.data);
    const tagB64 = forge.util.encode64(tag.data);
    //console.log('tag',tag.toHex());

    /*******************************************************************/
    /* RSA-OEAP ENCRYPT AES KEY
    /*******************************************************************/

    //console.log(environment[x_api_key].publicKey)
    const slug = environment.SLUG;
    const key = `PUBLIC_KEY_${slug}` as keyof typeof environment;
    const pk = environment[key] as string;

    var publicKey = forge.pki.publicKeyFromPem(pk);
    var buf = forge.util.createBuffer(aes_key, 'utf8');  // USE FOR RSA-OAEP
    var encryptedKey = publicKey.encrypt(buf.bytes(), 'RSA-OAEP', {
      md: forge.md.sha256.create(),
    });

    var ciphertext_rsa_B64 = forge.util.encode64(encryptedKey);

    let rsaKemSubmit: RsaKemSubmitInterface = {
      ciphertext_aes_B64: ciphertext_aes_B64,
      ciphertext_rsa_B64: ciphertext_rsa_B64,
      ivB64: ivB64,
      tagB64: tagB64
    }

    return rsaKemSubmit;


  } // end of kem

  getFriendlySlugText(slug: string): string {
    switch (slug.toLowerCase()) {
      case 'healent':
        return 'Healent';
      case 'akps':
        return 'AK Pain & Spine';
      case 'cps':
        return 'Commonwealth Pain & Spine';
      default:
        return slug;
    }
  }

  getFormControl(controlName: string): FormControl {
    return this.myForm.get(controlName) as FormControl;
  }

  onCardDetailsUpdated(cardDetails: {
    accountnumber: string;
    accountnumber_amex: string;
    cardsecuritycode: string;
    cardsecuritycode_amex: string;
    cardtype: string;
    expirationmonthmm: string;
    expirationyearyyyy: string;
  }): void {
    // Update the form with the new card details
    this.myForm.patchValue({
      accountnumber: cardDetails.accountnumber,
      accountnumber_amex: cardDetails.accountnumber_amex,
      cardsecuritycode: cardDetails.cardsecuritycode,
      cardsecuritycode_amex: cardDetails.cardsecuritycode_amex,
      cardtype: cardDetails.cardtype,
      expirationmonthmm: cardDetails.expirationmonthmm,
      expirationyearyyyy: cardDetails.expirationyearyyyy,
    });
    if (!this.myForm.get('expirationmonthmm')?.value && !this.myForm.get('expirationyearyyyy')?.value) {
      this.myForm.patchValue({
        expirationDate: ''
      });
      this.myForm.get('expirationyear')?.invalid
      this.myForm.get('expirationyear')?.markAsTouched();
      this.myForm.get('expirationyear')?.markAsDirty();
    }
    //console.log(this.myForm.value);
  }


  onAddressUpdated(addressDetails: { billingaddress: string; billingzip: string }): void {
    this.myForm.patchValue({
      billingaddress: addressDetails.billingaddress,
      billingzip: addressDetails.billingzip,
    });
  }
  checkFormValidation(): void {
    const invalidControls = Object.keys(this.myForm.controls).filter(key => {
      const control = this.myForm.get(key);
      console.log(`${key}:`, control?.invalid)
      return control && control.invalid;
    });

    if (invalidControls.length > 0) {
      invalidControls.forEach((key) => {
        const control = this.myForm.get(key);
        if (control) {
          control.markAsTouched();
          control.markAsDirty();
        }
      });
    }
  }


  getReadableControlName(controlName: string): string {
    const controlNamesMap: { [key: string]: string } = {
      nameoncard: 'Name on Card',
      cardtype: 'Card Type',
      billingaddress: 'Billing Address',
      billingzip: 'Billing ZIP',
      accountnumber: 'Account Number',
      accountnumber_amex: 'Account Number (AMEX)',
      cardsecuritycode: 'Card Security Code',
      cardsecuritycode_amex: 'Card Security Code (AMEX)',
      expirationmonthmm: 'Expiration Month',
      expirationyearyyyy: 'Expiration Year',
      expirationDate: 'Expiration Date',
      otheramount: 'Payment Amount',
    };

    return controlNamesMap[controlName] || controlName;
  }

  private resetForm() {
    this.myForm.patchValue({
      nameoncard: '',
      cardtype: '',
      accountnumber: '',
      accountnumber_amex: '',
      cardsecuritycode: '',
      cardsecuritycode_amex: '',
      expirationmonthmm: '',
      expirationyearyyyy: '',
      expirationDate: '',
    });

    Object.keys(this.myForm.controls).forEach((key) => {
      const control = this.myForm.get(key);
      if (control) {
        control.markAsPristine();
        control.markAsUntouched();
        control.updateValueAndValidity();
      }
    });
  }


  onSubmit() {
    this.errorMessage = '';
    this.isSubmitting = true;

    const clientIdMeta = document.querySelector('meta[name="patientId"]');
    const client_id = clientIdMeta?.getAttribute('content') ?? this.pid;
    const currentQueryParams = this.route.snapshot.queryParams;
    const clientInfo = {
      client_id: parseInt(client_id, 10),
      client_mrn: parseInt(this.mrn, 10),
      meeting_id: currentQueryParams['meetingId']
    };

    let paymentData: any;

    if (this.selectedCard === 'newCard') {
      if (this.myForm.invalid) {
        this.checkFormValidation();
        this.isSubmitting = false;
        this.isPayNowLoading = false;
        return;
      }
      this.myForm.disable();

      let newCardPaymentDetails = {
        ...this.myForm.value
      };

      paymentData = {
        payment: newCardPaymentDetails,
        client_info: clientInfo,
        store_card: this.myForm.get('saveCardDetails')?.value
      };
    } else {
      const selectedSavedCard = this.cardsList.find(card => card.id === this.selectedCard);
      if (!selectedSavedCard || !selectedSavedCard.originalCardData) {
        this.snackBar.open('Error: Selected saved card details not found.', 'OK', { duration: 5000, panelClass: ['error-snackbar'] });
        this.isSubmitting = false;
        this.isPayNowLoading = false;
        return;
      }
      let savedCardPaymentDetails = {
        appointmentid: this.currentAppointmentId,
        copayamount: this.currentCopayAmountFromApi,
        departmentid: this.currentDepartmentId,
        otheramount: this.payNowButtonAmount,
        patientid: parseInt(client_id, 10),
        practiceid: this.currentPracticeId,
        ...selectedSavedCard.originalCardData,
        cardsecuritycode: this.savedCardCvvForm.get('cvv')?.value
      };

      paymentData = {
        payment: savedCardPaymentDetails,
        client_info: clientInfo
      };
    }

    let paymentdataJson = JSON.stringify(paymentData);

    let rsaKemSubmit = this.rsaKem(paymentdataJson);
    const endpoint = `secure/payment?ciphertext_aes_B64=${rsaKemSubmit.ciphertext_aes_B64}&ciphertext_rsa_B64=${rsaKemSubmit.ciphertext_rsa_B64}&ivB64=${rsaKemSubmit.ivB64}&tagB64=${rsaKemSubmit.tagB64}`;

    this.directorService.get(endpoint).subscribe(
      (response) => {
        this.isSubmitting = false;
        this.isPayNowLoading = false;
        this.myForm.enable();
        if (response.status === 200) {
          // Success case
          this.errorMessage = null;
          const consentsFormsIncomplete = currentQueryParams['consents_forms_incomplete'];
          const remainingBalance = this.totalBalance - this.payNowButtonAmount;
          
          this.router.navigate(['/done'], {
            queryParams: {
              ...consentsFormsIncomplete ? { consents_forms_incomplete: consentsFormsIncomplete } : {},
              remainingBalance: remainingBalance,
              weblogin: currentQueryParams['weblogin']
            }
          });
        } else {
          this.errorMessage = `Error: ${response?.error || response?.message || 'Unknown error'}`;
          this.snackBar.open(this.errorMessage, 'Close', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['error-snackbar']
          });
          this.resetForm();
          this.myForm.enable();
          this.isSubmitting = false;
          this.isPayNowLoading = false;
        }
      },
      (error) => {
        // Error case
        this.isSubmitting = false;
        this.isPayNowLoading = false;
        setTimeout(() => {
          this.is_loading = false;
        }, 2000);
        this.myForm.enable();
        this.myForm.reset();
        this.errorMessage = error?.error?.status_code ? `Payment failed: 403 Forbidden` : `Payment failed: ${error?.error || error?.error?.message || error?.message || 'Unknown error'}`;
        this.snackBar.open(this.errorMessage, 'Close', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          panelClass: ['error-snackbar']
        });

        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({ status: error.status, message: this.errorMessage })
          );
        }
      }
    );
  }

  onCardSelect(cardId: string): void {
    if (this.selectedCard === cardId) {
      return;
    }

    this.selectedCard = cardId;

    if (cardId !== 'newCard') {
      const selectedCardData = this.cardsList.find(card => card.id === cardId);
      this.selectedSavedCardType = selectedCardData?.type || '';

      // Reset the CVV when new card is selected
      this.savedCardCvvForm.reset();
      this.savedCardCvvForm.get('cvv')?.clearValidators();
      this.savedCardCvvForm.get('cvv')?.markAsPristine();
      this.savedCardCvvForm.get('cvv')?.markAsUntouched();
    }
  }

  initializePaymentOptions(): void {
    const options: PaymentOptionItem[] = [];

    if (this.totalBalance > 0) {
      options.push({ id: 'full', label: 'Pay balance in full', amount: this.totalBalance });
    }
    options.push({ id: 'partial', label: 'Pay Custom Amount' });
    // options.push({ id: 'plan', label: 'Payment plan' });

    this.paymentOptions = options;

    if (this.totalBalance > 0 && this.paymentOptions.some(opt => opt.id === 'full')) {
      this.selectedPaymentOptionId = 'full';
      this.payNowButtonAmount = this.totalBalance;
      this.onOptionSelect('full');
    } else {
      this.selectedPaymentOptionId = 'partial';
      this.payNowButtonAmount = 0;
      this.onOptionSelect('partial');
    }
  }

  private _formatPartialAmountForDisplay(control: FormControl, numericValue: number | string): void {
    let cleanedNumericString: string;

    if (typeof numericValue === 'number') {
      cleanedNumericString = numericValue.toFixed(2);
    } else {
      cleanedNumericString = numericValue.replace(/[^0-9.]/g, '');
      const parts = cleanedNumericString.split('.');
      if (parts.length > 2) {
        cleanedNumericString = parts[0] + '.' + parts[1].substring(0, 2);
      } else if (parts.length === 2) {
        cleanedNumericString = parts[0] + '.' + parts[1].substring(0, 2);
      }
    }

    let formattedDisplayValue = '';
    if (cleanedNumericString === '' || cleanedNumericString === '0' || cleanedNumericString === '0.00') {
      formattedDisplayValue = '';
    } else if (cleanedNumericString.startsWith('.')) {
      formattedDisplayValue = `$ 0${cleanedNumericString}`;
    } else {
      formattedDisplayValue = `$ ${cleanedNumericString}`;
    }

    control.setValue(formattedDisplayValue, { emitEvent: false });
  }

  onOptionSelect(optionId: string): void {
    if (this.clickBlockedForSnack) {
      return;
    }

    const validOptionIds = ['full', 'partial', 'plan'];
    if (!optionId || !validOptionIds.includes(optionId)) {
      console.warn('onOptionSelect called with invalid or undefined optionId. Ignoring:', optionId);
      return;
    }

    if (this.selectedPaymentOptionId === optionId) {
      return;
    }
    this.selectedPaymentOptionId = optionId;

    if (optionId === 'full') {
      this.payNowButtonAmount = this.balance;
      // Change to partialAmountForm
      const control = this.partialAmountForm.get('partialAmount') as FormControl;
      this._formatPartialAmountForDisplay(control, '');
      control.markAsPristine();
      control.markAsUntouched();
    } else if (optionId === 'partial') {
      // Change to partialAmountForm
      const control = this.partialAmountForm.get('partialAmount') as FormControl;
      
      // Initialize with empty field and reset state
      this.isPartialAmountEntered = false;
      this.payNowButtonAmount = 0;
      control.setValue('', { emitEvent: false });
      control.markAsUntouched();
      control.markAsPristine();

      // Change to partialAmountForm
      this.partialAmountForm.get('partialAmount')?.setValidators([
        Validators.required,
        Validators.min(this.minPartialAmount),
        Validators.max(this.balance > 0 ? this.balance : 999999)
      ]);
      this.partialAmountForm.get('partialAmount')?.updateValueAndValidity();
      setTimeout(() => {
        if (this.partialAmountInputField) {
          this.partialAmountInputField.nativeElement.focus();
        }
      }, 100);
    } else if (optionId === 'plan') {
      this.payNowButtonAmount = 0;
      // Change to partialAmountForm
      const control = this.partialAmountForm.get('partialAmount') as FormControl;
      this._formatPartialAmountForDisplay(control, '');
      control.markAsPristine();
      control.markAsUntouched();
    }
  }

  onPartialAmountInput(event: Event): void {
    // Change to partialAmountForm
    const control = this.partialAmountForm.get('partialAmount') as FormControl;
    let input = (event.target as HTMLInputElement).value;

    let cleanedInput = input.replace(/[^0-9.]/g, '');

    const parts = cleanedInput.split('.');
    if (parts.length > 2) {
      cleanedInput = parts[0] + '.' + parts[1].substring(0, 2);
    } else if (parts.length === 2) {
      cleanedInput = parts[0] + '.' + parts[1].substring(0, 2);
    }

    const numericValue = parseFloat(cleanedInput);
    if (!isNaN(numericValue)) {
      this.payNowButtonAmount = numericValue;
      this.isPartialAmountEntered = true;
    } else {
      this.payNowButtonAmount = 0;
      this.isPartialAmountEntered = false;
    }

    let formattedDisplayValue = '';
    if (cleanedInput === '') {
      formattedDisplayValue = '';
    } else {
      formattedDisplayValue = `$${cleanedInput}`;
    }

    control.setValue(formattedDisplayValue, { emitEvent: false });

    // Clear error state when user starts typing
    this.showInputError['partialAmount'] = false;
  }

  onPartialAmountBlur(): void {
    // Change to partialAmountForm
    const control = this.partialAmountForm.get('partialAmount') as FormControl;
    let value = control?.value;

    let numericValue = parseFloat(value?.replace(/[^0-9.]/g, '') || '0');

    if (value && numericValue > 0) {
      if (numericValue > 1500) {
        this.snackBar.open(
          'The amount cannot exceed $1500.00. Adjusted to $1500.00.',
          'Close',
          {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: ['error-snackbar']
          }
        );
        this.clickBlockedForSnack = true; // Set flag to block clicks
        setTimeout(() => {
          this.clickBlockedForSnack = false; // Unblock after a delay
          // ... re-focus input ...
        }, 300);
        numericValue = 1500;
      }

      this.payNowButtonAmount = numericValue;
      this.isPartialAmountEntered = true;

      this._formatPartialAmountForDisplay(control, numericValue);

      control.updateValueAndValidity();
    } else {
      this.payNowButtonAmount = 0;
      this.isPartialAmountEntered = false;
      control.setValue('', { emitEvent: false });
      control.updateValueAndValidity();
    }
  }

  onCvvInput(): void {
    // Clear error state when user starts typing
    this.showInputError['cvv'] = false;
  }

  getPayNowButtonText(): string {
    const formattedAmount = this.currencyPipe.transform(this.payNowButtonAmount, 'USD', 'symbol', '1.2-2');
    return this.isPayNowLoading ? 'Processing...' : `Pay Now (${formattedAmount})`;
  }

  private get isPaymentOptionAmountValid(): boolean {
    if (this.selectedPaymentOptionId === 'full') {
      return this.totalBalance > 0;
    }
    if (this.selectedPaymentOptionId === 'partial') {
      return !this.partialAmountForm.invalid && this.payNowButtonAmount > 0;
    }
    return false;
  }

  private get isSavedCardCvvValid(): boolean {
    const cvvControl = this.savedCardCvvForm.get('cvv');
    if (!cvvControl || !cvvControl.value) {
      return false;
    }

    const cvvValue = cvvControl.value;
    const cardType = this.selectedSavedCardType;

    if (cardType === 'amex') {
      return cvvValue.length === 4;
    }
    return cvvValue.length === 3;
  }

  private get isCardDetailsValidForSubmission(): boolean {
    if (this.selectedCard === 'newCard') {
      return true;
    }
    return this.isSavedCardCvvValid;
  }

  isPayNowButtonDisabled(): boolean {
    return !this.isPaymentOptionAmountValid || !this.isCardDetailsValidForSubmission || this.isPayNowLoading;
  }

  onPayNowClick(): void {
    this.isPayNowLoading = true;
    this.amountToPay = this.currencyPipe.transform(this.payNowButtonAmount, 'USD', 'symbol', '1.2-2') || `$0.00`;
    this.myForm.get('otheramount')?.setValue(this.payNowButtonAmount)

    if (this.selectedPaymentOptionId === 'partial') {
      const partialAmountControl = this.partialAmountForm.get('partialAmount');
      if (!partialAmountControl?.value || this.payNowButtonAmount <= 0) {
        partialAmountControl?.markAsTouched();
        partialAmountControl?.markAsDirty();
        this.showInputError['partialAmount'] = true;
        this.snackBar.open('Please enter a valid amount to pay.', 'OK', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['error-snackbar']
        });
        this.isPayNowLoading = false;
        return;
      }
      // Clear error state if validation passes
      this.showInputError['partialAmount'] = false;
    }

    if (this.selectedCard === 'newCard') {
      this.proceedToPayment();
    } else {
      const cvvControl = this.savedCardCvvForm.get('cvv');
      if (!cvvControl?.value) {
        cvvControl?.markAsTouched();
        cvvControl?.markAsDirty();
        this.showInputError['cvv'] = true;
        this.snackBar.open('Please enter the security code.', 'OK', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          panelClass: ['error-snackbar']
        });
        this.isPayNowLoading = false;
        return;
      }

      const cvvValue = cvvControl.value;
      const cardType = this.selectedSavedCardType;

      if (cardType === 'amex' && cvvValue.length !== 4) {
        this.showInputError['cvv'] = true;
        this.snackBar.open('American Express security code must be 4 digits.', 'OK', { duration: 5000, panelClass: ['error-snackbar'] });
        this.isPayNowLoading = false;
        return;
      } else if (cardType !== 'amex' && cvvValue.length !== 3) {
        this.showInputError['cvv'] = true;
        this.snackBar.open('Security code must be 3 digits.', 'OK', { duration: 5000, panelClass: ['error-snackbar'] });
        this.isPayNowLoading = false;
        return;
      }
      
      // Clear error state if validation passes
      this.showInputError['cvv'] = false;
      this.onSubmit();
    }
  }

  goBackToPaymentOptions(): void {
    if (this.isSkipPaymentLoading || this.isSkipDirectLoading) {
      return;
    }
    this.dirPay = 'false';
    this.isPayNowLoading = false;
    this.isSkipDirectLoading = false;
    this.skipPaymentError = '';
  }

  toggleAdvancedOptions(): void {
    if (this.isSkipPaymentLoading || this.isSkipDirectLoading) {
      return;
    }
    this.showAdvancedOptionsPage = true;
    this.isPayNowLoading = false;
    this.isSkipDirectLoading = false;
    this.skipPaymentError = '';
  }

  goBackFromAdvancedOptions(): void {
    if (this.isSkipPaymentLoading || this.isSkipDirectLoading) {
      return;
    }
    this.showAdvancedOptionsPage = false;
    this.isPayNowLoading = false;
    this.isSkipDirectLoading = false;
    this.skipPaymentError = '';
  }

} // end of class
